export default __webpack_public_path__ + "static/media/Localised Expertise.83e8ee8e.svg";